import { h } from 'vue';
import { RouterLink } from 'vue-router';
import { DeleteOutlined, EditOutlined, PlusOutlined } from '@ant-design/icons-vue';
import { Button, Tag } from 'ant-design-vue';
import { getStatusColor } from '@/utility/statusColorUtils';

/**
 * Helper function to compute all flags related to verification permissions and status
 * @param {Object} item - The KPI item
 * @param {Object} profile - User profile information
 * @param {Object} filters - Current filters applied
 * @param {Function} checkPermission - Function to check user permissions
 * @param {Function} handleDeleteVerifikasi - Handler function for delete verification action
 * @returns {Object} - Object containing verification buttons and flags
 */
export function getVerifikasiFlags(item, profile, filters, checkPermission, handleDeleteVerifikasi) {
  const isEpi = profile.jenis_perusahaan != 'anak';
  const isPengurang = item.jenis_variable_kpi_id == 3;
  const isAbleCreateVerifikasi =
    (item.target && item.realisasi && !item.vrealisasi && item.realisasi_status == 'REL') ||
    (isPengurang && !item.verifikasiN);
  const isAbleUpdateVerifikasi =
    (item.vrealisasi && item.realisasi_status == 'REL') || (isPengurang && item.verifikasiN);
  const isAbleDeleteVerifikasi =
    (item.vrealisasi && item.realisasi_status == 'REL') || (isPengurang && item.verifikasiN);
  // const isCurrentLogin = profile.entitas_id === filters.entitas;
  const isButtonCreateVerifikasi = isAbleCreateVerifikasi && isEpi;
  const isButtonUpdateVerifikasi = isAbleUpdateVerifikasi && isEpi;
  const isButtonDeleteVerifikasi = isAbleDeleteVerifikasi && isEpi;

  const deleteButton = h(Button, {
    shape: 'circle',
    icon: h(DeleteOutlined),
    size: 'small',
    style: 'background-color: transparent; border: none; color: #555',
    onClick: () => handleDeleteVerifikasi(item.vrealisasi_id, item.name, filters.bulan, filters.tahun),
  });

  const updateButton = h(
    RouterLink,
    {
      to: `/nko-rekap-edit-verifikasi/${item.vrealisasi_id}`,
    },
    {
      default: () =>
        h(Button, {
          shape: 'circle',
          icon: h(EditOutlined),
          size: 'small',
          style: 'background-color: transparent; border: none; color: #555',
        }),
    },
  );

  const createButton = h(
    RouterLink,
    {
      to: `/nko-rekap-add-verifikasi/${item.kpi_id}/${filters.bulan}/${filters.tahun}`,
    },
    {
      default: () =>
        h(Button, {
          shape: 'circle',
          icon: h(PlusOutlined),
          size: 'small',
          style: 'background-color: transparent; border: none; color: #555',
        }),
    },
  );

  const vrealisasiStatus = item.vrealisasi_status
    ? h(Tag, { color: getStatusColor(item.vrealisasi_status) }, [item.vrealisasi_status])
    : null;

  const delVerifikasi = isButtonDeleteVerifikasi ? deleteButton : null;
  const updateVerifikasi = isButtonUpdateVerifikasi ? updateButton : null;
  const createVerifikasi = isButtonCreateVerifikasi ? createButton : null;

  return {
    isAbleCreateVerifikasi,
    isAbleUpdateVerifikasi,
    isAbleDeleteVerifikasi,
    isButtonCreateVerifikasi,
    isButtonUpdateVerifikasi,
    isButtonDeleteVerifikasi,
    createVerifikasi,
    updateVerifikasi,
    delVerifikasi,
    vrealisasiStatus,
  };
}
